export const normalizePhoneNumber = (phone: string): string => phone.replace(/[^\d+]/g, '').replace(/(\+)?(\d+)/, '+$2')
